import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * DemoBanner Component
 * 
 * Warning banner for demo/development pages.
 * Only shown in development/preview environments.
 */

const DemoBanner: React.FC = () => {
  // Only show in dev or preview
  if (!import.meta.env.DEV && import.meta.env.VITE_IS_PREVIEW !== 'true') {
    return null;
  }

  return (
    <div 
      className="bg-warning-50 border-l-4 border-warning-500 p-4 mb-6 dark:bg-warning-900/20 dark:border-warning-600"
      role="status"
    >
      <div className="flex items-start gap-3">
        <AlertCircle className="text-warning-500 flex-shrink-0 mt-0.5" size={20} />
        <div>
          <h4 className="text-sm font-semibold text-warning-900 dark:text-warning-100">
            Development/Preview Mode
          </h4>
          <p className="text-sm text-warning-700 dark:text-warning-200 mt-1">
            This is a demo page for UI/UX development. It is only visible in development and preview environments.
            {' '}
            <span className="font-medium">This page will not be accessible in production.</span>
          </p>
        </div>
      </div>
    </div>
  );
};

DemoBanner.displayName = 'DemoBanner';

export default DemoBanner;
